/**
 * Sticky "Cobra intent" marker.
 *
 * Set when a member enters through the branded `/cobra` funnel. It's UX-only
 * intent — it survives /register, /login, refresh, and back-nav so a member who
 * clicked the Cobra link never silently falls out of the free flow. It grants
 * NOTHING on its own: the coupon is applied server-side only if the authenticated
 * email is on the allowlist (see docs/cobra-migration-bearings.md). A forged
 * marker just shows Cobra UI to someone who then fails the server check.
 *
 * localStorage (not sessionStorage) so it persists across the OAuth/registration
 * round-trip and tab restores.
 */

const KEY = 'edge.cobra.intent'

export function setCobraIntent(): void {
  try {
    localStorage.setItem(KEY, '1')
  } catch {
    // storage disabled (private mode / quota) — intent is best-effort UX
  }
}

export function hasCobraIntent(): boolean {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function clearCobraIntent(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}
